// File: src/components/EventPreview/WhereToMeetCard.jsx
import React from "react";
import {
  LuChevronRight,
  LuMapPin,
} from "react-icons/lu";

export default function WhereToMeetCard({
  title = "Where to meet",
  subtitle = "View meeting spot and arrival instructions",
  onClick,
}) {
  return (
    <button
      type="button"
      style={styles.card}
      onClick={onClick}
    >
      <div style={styles.iconWrap}>
        <LuMapPin
          size={16}
          strokeWidth={2.2}
        />
      </div>

      <div style={styles.copy}>
        <div style={styles.title}>
          {title}
        </div>

        <div style={styles.subtitle}>
          {subtitle}
        </div>
      </div>

      <LuChevronRight
        size={17}
        strokeWidth={2.35}
        style={styles.chevron}
      />
    </button>
  );
}

const styles = {
card: {
  width: "calc(100% - 20px)",
  margin: "0px 10px",
  padding: "20px 0px 12px 0px",
    border: "none",
    borderRadius: 0,
    background: "#fff",
    display: "flex",
    alignItems: "center",
    gap: 10,
    textAlign: "left",
    cursor: "pointer",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },

  iconWrap: {
    width: 32,
    height: 32,
    borderRadius: 999,
    background: "#FBE67A",
    color: "#111",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  copy: {
    flex: 1,
    minWidth: 0,
  },

  title: {
    color: "#0B0B0B",
    fontSize: 12.5,
    lineHeight: 1.05,
    fontWeight: 800,
    letterSpacing: "-0.025em",
  },

  subtitle: {
    marginTop: 4,
    color: "rgba(17,17,17,0.58)",
    fontSize: 11.5,
    lineHeight: 1.2,
    fontWeight: 500,
    letterSpacing: "-0.012em",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  chevron: {
    color: "#111",
    flexShrink: 0,
    marginLeft: 4,
    marginRight: 2,
  },
};